import { css } from '@emotion/react'

export const fontPrimary = css`
    font-family: Montserrat, monospace;
`
export const fontSecondary = css`
    font-family: 'Overpass Mono', monospace;
`
